import React from 'react';
import './index.scss';
import { Form, Input } from 'semantic-ui/semantic-ui-imports';

interface Props {
  nameFirst: string;
  nameSecond: string;
  label: string;
  defaultFirstValue: string | number | null;
  defaultSecondValue: string | number | null;
  onChange?: (name: string, val: number) => void;
  labelUnitFirst?: string;
  labelUnitSecond?: string;
  className?: string;
  disabled?: boolean;
}

const OneLineInputs = ({
  nameFirst,
  nameSecond,
  label,
  defaultFirstValue,
  defaultSecondValue,
  onChange,
  className = '',
  labelUnitFirst = '°C',
  labelUnitSecond = '%',
  disabled = false,
}: Props) => (
  <Form.Field className={`one-line-inputs ${className}`}>
    <label htmlFor={nameFirst}>{label}</label>
    <div>
      <Input
        name={nameFirst}
        label={{ basic: true, content: labelUnitFirst }}
        labelPosition="right"
        defaultValue={defaultFirstValue || ''}
        onChange={(e: { target: { value: string } }) =>
          onChange && onChange(nameFirst, parseInt(e.target.value, 10))
        }
        disabled={disabled}
      />
      <Input
        name={nameSecond}
        label={{ basic: true, content: labelUnitSecond }}
        labelPosition="right"
        defaultValue={defaultSecondValue || ''}
        onChange={(e: { target: { value: string } }) =>
          onChange && onChange(nameSecond, parseInt(e.target.value, 10))
        }
        disabled={disabled}
      />
    </div>
  </Form.Field>
);

export default OneLineInputs;
